import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack } from '@mui/material';
import { KnownBySection } from '../KnownBySection.js';
import { NotesSection } from '../NotesSection.js';
export function AdminTab(props) {
    const { character, canEdit } = props;
    return (_jsxs(Stack, { spacing: 3, children: [_jsx(NotesSection, { character: character, canEdit: canEdit }), _jsx(KnownBySection, { character: character, canEdit: canEdit })] }));
}
//# sourceMappingURL=AdminTab.js.map